import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { WindowsDirectionFilter } from '../../../../models/Filter';
import { WindowDirectionNewFilter } from '../../windowsDirection/WindowsDirectionNewFilter';

interface IWindowDirectionFilter {
    filter: WindowsDirectionFilter;
    handleChange: (value: WindowsDirectionFilter) => void;
    classNameGroup?: string;
}

export const MobileWindowDirectionFilterButtonView: React.FC<IWindowDirectionFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Вид из окна'>
            <WindowDirectionNewFilter
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
